// extracted by mini-css-extract-plugin
export var createdDate = "_lc-1";
export var divider = "_lc-2";
export var headerDivider = "_lc-3";
export var messagesCard = "_lc-0";
export var messagesContainer = "_lc-6";
export var messagesContainerWrapper = "_lc-4";
export var showLeftPanelButton = "_lc-8";
export var topButtons = "_lc-7";
export var withPadding = "_lc-5";